import { useAppStyles } from "./hooks/useAppStyles";
import { useGetUserData } from "./hooks/useGetUserData";
import { useCheckPreferences } from "./hooks/useCheckPreferences";
import { useCheckExternalMessages } from "./hooks/useCheckExternalMessages";
import { useWindowHistoryByMouse } from "./hooks/useWindowHistoryByMouse";
import { useInitDocumentTitle } from "./hooks/useInitDocumentTitle";
import { useHideAllMenus } from "./hooks/useHideAllMenus";
import { useTrackVisit } from "@/components/app/AppHooks/hooks/useTrackVisit";
import { useFullScreen } from "./hooks/useFullScreen";
import { useCookieNotice } from "./hooks/useCookieNotice";
import { useStreamateCameras } from "./hooks/useStreamateCameras";
import { useGeoBlockedPage } from "./hooks/useGeoBlockedPage";
import { useTrackUser } from "./hooks/useTrackUser";
import { useOrientation } from "./hooks/useOrientation";
import { useTrackPWA } from "./hooks/useTrackPWA";
import { useResetSearchTag } from "./hooks/useResetSearchTag";
import { useHeaderScroll } from "./hooks/useHeaderScroll";
import { useScroll } from "./hooks/useScroll";
import { useDetectGeolocation } from "@/components/app/AppHooks/hooks/useDetectGeolocation";

export const AppHooks = () => {
  useGetUserData();
  useCheckPreferences();
  useCheckExternalMessages();
  useDetectGeolocation();
  useGeoBlockedPage();

  useTrackVisit();
  useAppStyles();
  useWindowHistoryByMouse();
  useInitDocumentTitle();
  useHideAllMenus();
  useFullScreen();
  useCookieNotice();
  useStreamateCameras();
  useTrackUser();
  useOrientation();
  useTrackPWA();
  useResetSearchTag();

  useHeaderScroll();
  useScroll();

  return null;
};
